import React from 'react';

const MainMenu = () => {
  return (
      <ul className="navigation">
        <li className="current dropdown">
          <a href="/">Anasayfa</a>
          <ul>
            <li><a href="/">Home page 01</a></li>
            <li><a href="/">Home page 02</a></li>
            <li><a href="/">Home page 03</a></li>
            <li className="dropdown">
              <a href="/">Single</a>
              <ul>
                <li><a href="/">Home Single 1</a></li>
                <li><a href="/">Home Single 2</a></li>
                <li><a href="/">Home Single 3</a></li>
              </ul>
            </li>
            <li className="dropdown">
              <a href="/hakkimizda">Dark</a>
              <ul>
                <li><a href="/">Home Dark 1</a></li>
                <li><a href="/">Home Dark 2</a></li>
              </ul>
            </li>
          </ul>
        </li>

        <li className="dropdown">
          <a href="/">Sayfalar</a>
          <ul>
            <li><a href="/">Hakkımızda</a></li>
            <li className="dropdown">
              <a href="/">Country</a>
              <ul>
                <li><a href="/">Country grid</a></li>
                <li><a href="/">Country details</a></li>
              </ul>
            </li>
            <li><a href="/">FAQ</a></li>
          </ul>
        </li>

        <li className="dropdown"><a href="/">Danışmanlık</a></li>
        <li className="dropdown"><a href="/">Vize</a></li>
        <li className="dropdown"><a href="/">Mağaza</a></li>
        <li className="dropdown"><a href="/">Haberler</a></li>
        <li><a href="/">İletişim</a></li>
      </ul>
  );
};

export default MainMenu;